import { ACFMediaFragment } from "@/fragments";
import { gql } from "@apollo/client";
export const Search = gql`
  ${ACFMediaFragment}
  query Search($searchTerm: String!, $language: String = "en", $size: Int = 9999, $offset: Int = 0, $exclude: [ID!] = [], $pageCategoryFilters: [ID!] = []) {
    search(
      where: {
        contentTypes: [CEREMONY, EVENT, EXHIBIT, PAGE, POST, INDUCTEE, RHTV_VIDEO, RHTV_CHANNEL, PRESS_RELEASE]
        search: $searchTerm,
        language: $language,
        pageCategoryFilters: $pageCategoryFilters,
        excludeFrontPage: true,
        excludeIds: $exclude,
        status: PUBLISH, 
        offsetPagination: {size: $size, offset: $offset}
      }
    ) {
      pageInfo {
        hasNextPage
        total
      }
      termCounts {
        termId
        termSlug
        count
      }
      nodes {
        contentTypeName
        ... on NodeWithTitle {
          title
        }
        ... on ContentNode {
          uri
          slug
          databaseId
        }
        ... on RhtvVideo {
          title
          slug
          rhtvVideoContent {
            videoTitle
            youtubeVideoId
            channels(first: 1) {
              nodes {
                uri
              }
            }
            thumbnail {
              ...ACFMedia
            }
          }
        }
        ... on RhtvChannel {
          title
          uri
          rhtvChannelContent {
            thumbnail {
              ...ACFMedia
            }
          }
        }
        ... on ContentNode {
          pageData {
            featuredImage {
              ...ACFMedia
            }
            pageCategory {
              name
              slug
            }
          }
        }
      }
      shopifyProducts {
        title
        onlineStoreUrl
        featuredImage {
          url
        }
        priceRange {
          minVariantPrice {
            amount
            currencyCode
          }
          maxVariantPrice {
            amount
            currencyCode
          }
        }
      }
    }
  }
`;